import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import {
  PageContainer,
  SectionTitle,
  Button,
  Divider,
  fadeIn,
  Footer,
  useGoBack,
  FormRow, FormGroup, Label, Input, FormRowFull, Toggle, ToggleInput
} from '../styles/PageStyles';
import { createModel, getModels, updateModel } from '../services/modelHubService';
import { useToast } from '../components/common/ToastProvider';


const ModelHubDetails = () => {
  const { modelId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [modelDetail, setModelDetail] = useState();
  const [currentSetupStep, setCurrentSetupStep] = useState(1);
  const {showToast} = useToast();



  // For Model Current
  useEffect(() => {
    const fetchModelByCode = async () => {
      try {
        const parsedmodelId = (modelId); // Parse entityId as a number

        let filter = {
          "code": parsedmodelId
        }
        const response = await getModels(filter, {});
        setModelDetail({
          ...response[0]
        });

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (modelId !== 'new') {
      fetchModelByCode();
    } else {
      if (user) {
        setModelDetail({
          code: "MDL-" + new Date().getTime(),
          company_cd: user.companyCd,
          name: "",
          type: "",
          status: "active",
          latency: "",
          version: "",
          provider: "",
          performance: 0,
          costPerToken: "$0.00010"
        });
      }
    }

  }, [modelId, user]);



  const getAttribType = (type) => {
    switch (type) {
      case 'STR':
        return 'String';
      case 'INT':
        return 'Integer';
      case 'FLOAT':
        return 'Float';
      case 'DATE':
        return 'Date';
      case 'ENTITY':
        return 'Entity';
      default:
        return type;
    }
  }
  const goBack = useGoBack();

  const saveModel = () => {
    try {
      if (modelDetail.id) {
        updateModel(modelDetail);
      } else {
        createModel(modelDetail);
      }
      showToast({
        message:'Model updated successfully.',
        type:'success'
      })
      navigate('/model-hub');
    } catch (error) {
      console.error('Error saving Model:', error);

    }
  }


  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {modelDetail?.name ? (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              {modelDetail?.name}
            </span>
          ) : (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              Add Model
            </span>
          )}
        </SectionTitle>
        <Divider />
        <FormRow>
          <FormGroup>
            <Label>Name</Label>
            <Input type="text" value={modelDetail?.name || ''} onChange={(e) => setModelDetail({ ...modelDetail, name: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Type</Label>
            <Input type="text" value={modelDetail?.type || ''} onChange={(e) => setModelDetail({ ...modelDetail, type: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Version</Label>
            <Input type="text" value={modelDetail?.version || ''} onChange={(e) => setModelDetail({ ...modelDetail, version: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Provider</Label>
            <Input type="text" value={modelDetail?.provider || ''} onChange={(e) => setModelDetail({ ...modelDetail, provider: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Latency</Label>
            <Input type="text" value={modelDetail?.latency || ''} onChange={(e) => setModelDetail({ ...modelDetail, latency: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Cost per Token</Label>
            <Input type="text" value={modelDetail?.costPerToken || ''} onChange={(e) => setModelDetail({ ...modelDetail, costPerToken: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Status</Label>
            <Input type="text" value={modelDetail?.status || ''} onChange={(e) => setModelDetail({ ...modelDetail, status: e.target.value })} />
          </FormGroup>

        </FormRow>

        <Footer>

          <div style={{ flex: '1' }}></div>
          <Button primary onClick={() => saveModel()}>
            <FontAwesomeIcon icon={faSave} /> Save Model</Button>
        </Footer>




      </motion.div>

    </PageContainer>
  );
}

export default ModelHubDetails;